module.exports = __webpack_public_path__ + "img/1-lg.ff162a0a.jpg";